__turbopack_context__.v({
  "featuredArticle": "InfiniteArticleList-module__ZTTrnq__featuredArticle",
  "gridList": "InfiniteArticleList-module__ZTTrnq__gridList",
});
